import { faKitchenSet } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ChildrenItem } from 'api/menuPlanner/GetMenuPlannerIdV1';
import 'components/desktop/_general/ImageSlider/ImageSlider.scss';
import * as ImageList from 'types/Media/ImageList';

interface IProps {
	images: ImageList.Type;
	id: string;
	children: ChildrenItem[];
}

const ImageSlider = (props: IProps) => {
	const chunkArray = (arr: any[], size: number) => {
		return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
			arr.slice(i * size, i * size + size)
		);
	};

	const images = props.children.map((child: { images: { url: string }[] }) => ({
		image: child.images?.[0],
		urlExists: Boolean(child.images?.[0]?.url),
		...child,
	}));

	const rows = chunkArray(images, 3);

	const renderContent = () => {
		if (props.children.length == 0)
			return (
				<>
					{props.images[0] && props.images[0].url ? (
						<img
							src={props.images[0].url}
							style={{
								height: '15vh',
								width: '100%',
								aspectRatio: '1 / 0.8',
								objectFit: 'cover',
								borderRadius: '1rem 1rem 0 0',
							}}
						/>
					) : (
						<div
							style={{
								height: '15vh',
								width: '100%',
								aspectRatio: '1 / 0.8',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderRadius: '1rem 1rem 0 0',
							}}
						>
							<FontAwesomeIcon icon={faKitchenSet} className="fa-5x" />
						</div>
					)}
				</>
			);
		return (
			<div
				style={{
					borderRadius: '1rem 1rem 0 0',
					height: '15vh',
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
				}}
			>
				{rows.map((row, rowIdx) => (
					<div
						key={rowIdx}
						style={{
							display: 'flex',
							flexDirection: 'row',
							height: `${100 / rows.length}%`,
							width: '100%',
						}}
					>
						{row.map((img, idx) => (
							<div
								key={idx}
								style={{
									height: '100%',
									width: `${100 / row.length}%`,
									objectFit: 'cover',
									padding: 0,
									borderRadius: 0,
									boxShadow: 'none',
									borderTop: rowIdx === 0 ? '' : '1px solid white',
									borderLeft: idx === 0 ? '' : '1px solid white',
									borderRight: idx === row.length - 1 ? '' : '1px solid white',
									borderBottom:
										rowIdx === rows.length - 1 ? '' : '1px solid white',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								{img.urlExists && img.image?.url ? (
									<img
										src={img.image.url}
										alt={`Gallery Image ${rowIdx * 3 + idx + 1}`}
										style={{
											height: '100%',
											width: `100%`,
											objectFit: 'cover',
											padding: 0,
											borderRadius: 0,
										}}
									/>
								) : (
									<div
										style={{
											height: '100%',
											width: '100%',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
										}}
									>
										<FontAwesomeIcon icon={faKitchenSet} />
									</div>
								)}
							</div>
						))}
					</div>
				))}
			</div>
		);
	};

	return <>{renderContent()}</>;
};

export default ImageSlider;
